<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green" class="mb-5" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <h4>Disciplina: {{ gestaoDeAula.disciplina.descricao }}</h4>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="12">
            <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
              <e-label>Tipo de Aula</e-label>
              <e-autocomplete
                :items="$constants.tiposDeAulas"
                :return-object="false"
                :error-messages="errors"
                v-model="aulaSelecionada.tipo_de_aula"
                @change="() => verificaTipoDaAula()"
                label="Selecione um tipo de aula"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row v-if="mostrarCampos">
          <v-col v-if="aulaSelecionada.bimestre_id !== null" class="pt-0 pb-0" cols="3">
            <div>
              <label>Bimestre</label>
              <v-select
                :disabled="aulaSelecionada.tipo_de_aula ? false : true"
                :items="bimestres"
                :return-object="false"
                @change="($event) => atualizarData($event)"
                v-model="aulaSelecionada.bimestre_id"
                :item-text="
                  (item) =>
                    item.status === 0 ? item.descricao : `${item.descricao} (Bimestre Bloqueado)`
                "
                :item-value="(item) => item.id"
                :item-disabled="(item) => item.status === 1"
                label="Selecione um bimestre"
                dense
                solo
              />
            </div>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="data"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <e-label>Selecione uma data</e-label>
                <v-text-field
                  v-model="aulaSelecionada.data"
                  persistent-hint
                  :disabled="
                    aulaSelecionada.tipo_de_aula && aulaSelecionada.bimestre_id ? false : true
                  "
                  label="Escolha uma data"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  solo
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="data"
                :min="bimestreSelecionado?.data_inicial"
                :max="bimestreSelecionado?.data_final"
                range
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(data)"> OK </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col class="pt-0 pb-0" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'" cols="6">
            <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
              <e-label class="mb-5">Selecione um horário</e-label>
              <e-autocomplete
                :disabled="aulaSelecionada.data ? false : true"
                :items="horariosList"
                :item-text="(item) => item.descricao"
                :return-object="false"
                :item-value="(item) => item.id"
                :error-messages="errors"
                v-model="horarios"
                label="Selecione uma opção"
                dense
                multiple
              />
            </ValidationProvider>
            <!-- @change="() => pesquisaAulas()" -->
          </v-col>

          <v-col
            cols="12"
            v-if="horarios || aulaSelecionada.tipo_de_aula === 'Aula Remota' || editing"
          >
            <ValidationProvider name="Conteúdo" rules="required" v-slot="{ errors }">
              <e-label>Conteúdo</e-label>
              <v-textarea solo dense v-model="aulaSelecionada.conteudo" :error-messages="errors" />
            </ValidationProvider>

            <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
              <e-label>Metodologia</e-label>
              <v-textarea
                solo
                dense
                v-model="aulaSelecionada.metodologia"
                :error-messages="errors"
              />
            </ValidationProvider>

            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              >Enviar Dados</v-btn
            >
            <v-btn v-if="editing" class="ml-3" color="success" @click="dialog.duplicar = true"
              >Duplicar Aula</v-btn
            >
            <v-btn v-if="editing" class="ml-3" color="success" @click="dialog.exportar = true"
              >Exportar Aula</v-btn
            >
          </v-col>
        </v-row>

        <v-row v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data || !horarioSelecionado">
          <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
            <v-alert type="warning" border="left"> Por favor, preencha todos os campos! </v-alert>
          </v-col>
        </v-row>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Fechar
          </v-btn>

          <h2 class="mt-4">Aulas conflitadas</h2>

          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor.nome }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item.turma.franquia.descricao }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horario.descricao }}
                  </td>
                  <td>{{ item.turma.descricao }}</td>
                  <td>{{ item.disciplina.descricao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <e-modal-duplicar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :horarios="horarios"
      :horariosList="horariosList"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.exportar = $event"
    >
    </e-modal-exportar-aula>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";
// import { dateFormat, dateFormatHour } from "@/plugins/filters";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },

  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
    ...mapGetters("Auth", ["user"]),
    data_bloqueado() {
      return this.adicionarUmDia(this.user?.data_bloqueio);
    },
  },
  mounted() {
    this.loadData();
    if (this.editing) {
      this.mostrarCampos = true;
      this.outrosCampos = true;
    }
  },
  data() {
    return {
      data: null,
      modal: false,
      menu: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      mostrarCampos: true,
      outrosCampos: false,
      submittingForm: false,
      form: {},
      aulaSelecionada: {
        data: null,
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      gestaoDeAulas: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horariosList: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      data_bloqueio: null,
      bimestres: [],
      bimestreSelecionado: null,
    };
  },
  watch: {
    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
      }
    },
    data(value) {
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");
    },
  },
  methods: {
    atualizarData(value) {
      this.bimestreSelecionado = this.bimestres.find((item) => item.id === value);
      if (this.editing) {
        this.aulaSelecionada.data = null;
        this.horarios = null;
      }
    },
    formatarData(data) {
      if (!data) return "";
      const [ano, mes, dia] = data.split("-"); // assume que vem no formato "yyyy-mm-dd"0
      return `${dia}/${mes}/${ano}`;
    },
    async loadBimestresDisponiveis() {
      const data = await this.$services.usuariosService.getBimestresDisponiveis();
      this.bimestres = data;
    },
    async pesquisaAulas() {
      const data_aula = this.aulaSelecionada.data;
      /* eslint-disable */
      const aula_id = this.$route.params.aula_id;
      const horario_id = this.horarioSelecionado.id;
      const turma_id = this.gestaoDeAula.turma.id;
      if (!data_aula || !this.horarioSelecionado || !this.aulaSelecionada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
        data_aula,
        horario_id,
        turma_id,
        aula_id
      );

      if (response.data.length <= 0) {
        this.mostrarCampos = true;
        this.outrosCampos = true;
      }

      if (response.data.length > 0) {
        this.aulasEmConflitos = true;
        this.outrosCampos = false;
        this.aulasConflitadas = response.data;
      }
    },
    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.outrosCampos = true;
        return;
      }
      this.mostrarCampos = true;
      this.outrosCampos = false;
    },
    async submitForm() {
      this.aulaSelecionada.horarios = this.horarios;
      this.aulaSelecionada.horario_inicial = this.horarioSelecionado
        ? this.horarioSelecionado.inicio
        : null;
      this.aulaSelecionada.horario_final = this.horarioSelecionado
        ? this.horarioSelecionado.final
        : null;
      this.aulaSelecionada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;

      this.submittingForm = true;
      try {
        if (this.editing) {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasService.atualizar(this.aulaSelecionada);
          this.$toast.success("Aula editada com sucesso!");
        } else {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.disciplina_id = this.gestaoDeAula.disciplina_id;
          this.aulaSelecionada.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
          this.aulaSelecionada.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasService.criarAula(this.aulaSelecionada);
          this.$toast.success("Aula cadastrada com sucesso!");
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
      // this.$router.push({
      //   name: "aulas",
      // });
    },

    async getAula() {
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );

      this.gestaoDeAula = response.payload.gestaoDeAula;
      this.horariosList = response.payload.horarios || [];

      const aulaSelecionada = await this.$services.aulasService.getAula(parseInt(aula_id, 10));

      // Se 'aulaSelecionada.horarios' for um array, usamos ele diretamente.
      // Se não, pegamos o 'id' de 'aulaSelecionada.horario', em um array de id's.
      this.horarios = Array.isArray(aulaSelecionada.horarios)
        ? aulaSelecionada.horarios
        : aulaSelecionada.horario
        ? [aulaSelecionada.horario.id]
        : [];
      if (aulaSelecionada.bimestre_id) {
        this.bimestreSelecionado = this.bimestres.find(
          (item) => item.id === aulaSelecionada.bimestre_id
        );
      }
      return aulaSelecionada;
    },

    async loadData() {
      try {
        this.$loaderService.open("Carregando dados...");
        this.aulaSelecionada = await this.getAula();
        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }
        this.loadBimestresDisponiveis();
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    adicionarUmDia(dataString) {
      let data = new Date(dataString);
      // console.log(data);
      data.setDate(data.getDate() + 2);
      let year = data.getFullYear();
      let month = ("0" + (data.getMonth() + 1)).slice(-2);
      let day = ("0" + data.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.dataInput {
  background-color: white;
  width: 100%;
  height: 35px;
  box-shadow: 2px 2px rgb(0, 0, 0, 0.1);
}
</style>
